/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for an alarm horn strobe.
 */
export type AnimaticAlarmHornStrobeConfig = {};

/** @internal */
export const AnimaticAlarmHornStrobeConfig$inboundSchema: z.ZodType<
  AnimaticAlarmHornStrobeConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticAlarmHornStrobeConfig$Outbound = {};

/** @internal */
export const AnimaticAlarmHornStrobeConfig$outboundSchema: z.ZodType<
  AnimaticAlarmHornStrobeConfig$Outbound,
  z.ZodTypeDef,
  AnimaticAlarmHornStrobeConfig
> = z.object({});

export function animaticAlarmHornStrobeConfigToJSON(
  animaticAlarmHornStrobeConfig: AnimaticAlarmHornStrobeConfig,
): string {
  return JSON.stringify(
    AnimaticAlarmHornStrobeConfig$outboundSchema.parse(
      animaticAlarmHornStrobeConfig,
    ),
  );
}
export function animaticAlarmHornStrobeConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticAlarmHornStrobeConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticAlarmHornStrobeConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticAlarmHornStrobeConfig' from JSON`,
  );
}
